import { ScheduleRange } from 'store/scheduleRanges/interfaces';
import { Schedule } from 'store/schedules/interfaces';

export interface ScheduleWorkingDay {
  day: number;
  ranges: ScheduleRange[];
}

export default function generateScheduleWorkingDays(
  schedule: Schedule,
): ScheduleWorkingDay[] {
  const scheduleWorkingDays: ScheduleWorkingDay[] = [];

  for (let day = 1; day < schedule.numberOfDays; day++) {
    scheduleWorkingDays.push({
      day,
      ranges: schedule.scheduleRanges.filter((range) => range.day === day),
    });
  }

  return scheduleWorkingDays;
}
